<template>
  <layout-basic>
    <page-hero
      title="Webinars"
      lead="On-demand webinars and recordings for growing businesses."
    />

    <section class="resource-shell">
      <v-container>
        <p class="resource-shell__note">
          On-demand webinar recordings will appear here. Until then, watch the
          product demo or experience IMPROVE for yourself.
        </p>
      </v-container>
    </section>

    <point-grid :points="points" :columns="2" tint />
    <standard-cta />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'Webinars',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Webinars | IMPROVE',
      description: 'On-demand webinars and recordings for growing businesses.',
      path: '/resources/webinars',
    });
  },
  data() {
    return {
      points: [
        'Employee onboarding that scales',
        'Compliance without the complexity',
        'Building better managers',
        'Getting the most from IMPROVE',
      ],
    };
  },
};
</script>

<style scoped>
.resource-shell {
  padding: 8px 0 24px;
}

.resource-shell__note {
  text-align: center;
  max-width: 560px;
  margin: 0 auto 8px;
  color: var(--brand-grey, #6b7280);
  font-size: 15px;
  line-height: 1.5;
}
</style>
